<h2 mat-dialog-title>{{ data.modalTitle }}</h2>

<mat-dialog-content>
  <form [formGroup]="uploadForm">

    <!-- Pool Point -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Pool Point</mat-label>
      <mat-select formControlName="pool_point_uuid" (selectionChange)="onPoolPointChange($event.value)">
        <mat-option *ngFor="let pp of poolPoints" [value]="pp.value">
          {{pp.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Customer -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Customer</mat-label>
      <mat-select formControlName="pool_point_client_uuid" (selectionChange)="onClientChange($event.value)">
        <mat-option *ngFor="let c of clients" [value]="c.value">
          {{c.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Distribution Center -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Distribution Center</mat-label>
      <mat-select formControlName="customer_contact_distribution_center_uuid">
        <mat-option *ngFor="let dc of distributionCenters" [value]="dc.value">
          {{dc.label}} ({{dc.reference}})
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- File Upload -->
    <ng-container *ngIf="allSelectsChosen()">
      <input type="file" accept=".csv,.txt" (change)="onFileSelected($event)" />
    </ng-container>

    <!-- Shipment List -->
    <div formArrayName="shipments" class="shipment-list">
      <mat-card *ngFor="let group of shipments.controls; let i = index" [formGroupName]="i" class="shipment-card">
        <div class="store-header">
          <mat-form-field appearance="outline" class="store-number-field">
            <mat-label>Store #</mat-label>
            <input matInput formControlName="store_number" />
          </mat-form-field>

          <button mat-icon-button color="warn" (click)="removeShipment(i)" aria-label="Remove shipment">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div class="shipment-fields">
          <mat-form-field appearance="fill">
            <mat-label>Products</mat-label>
            <input matInput formControlName="products" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Weight</mat-label>
            <input matInput formControlName="weight" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>BOL</mat-label>
            <input matInput formControlName="external_bill_of_lading" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Trailer</mat-label>
            <input matInput formControlName="trailer_id" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>ASN</mat-label>
            <input matInput formControlName="asn_number" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Alt Ref</mat-label>
            <input matInput formControlName="alternate_reference" />
          </mat-form-field>
        </div>
      </mat-card>
    </div>

    <!-- Add Shipment Button -->
    <button mat-stroked-button color="primary" type="button" class="add-shipment-btn" (click)="addShipment()">
      + Add Shipment
    </button>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!uploadForm.valid">Upload</button>
</mat-dialog-actions>
